<template>
  <div class="upload-reject-material-list">

    <div class="reject-material-list">
      <div class="upload-item-box" v-for="(upload, index) in fileSet" :key="upload.id || index">
        <update-upload-material 
          :upload="upload"
          :first-upload="isFirstUpload"
          @replaceItem="replaceFileSetItem"
          @deleteItem="deleteFileSetItem"
          :applicant-id="applicant.applicant_id"
        ></update-upload-material>
      </div>
      <div class="upload-item-box" v-if="showUploadBtn">
        <add-upload-material 
          :max-length="maxLength"
          :material-list="fileSet"
          :first-upload="isFirstUpload"
          @addNewItemList="addFileSetItemList"
          :applicant-id="applicant.applicant_id"
          >
        </add-upload-material>
      </div>
    </div>

    <div class="reject-material-tips">最多支持上传10张，格式支持jpg、jpeg、png，大小2M</div>
  </div>
</template>

<script>
import AddUploadMaterial from './components/add-upload-material.vue';
import UpdateUploadMaterial from './components/update-upload-material.vue';
import utils from '@/libs/utils';

export default {
  props: {
    fileSet: {
      type: Array,
      default: () => [],
    },
    applicant: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    AddUploadMaterial,
    UpdateUploadMaterial,
  },
  data() {
    return {
      maxLength: 10,
    };
  },
  computed: {
    // 判断是否为第一次新增，如果是不发接口给后端，否则都需要调用后端接口
    isFirstUpload() {
      return !this.applicant || this.applicant.file_status === 0;
    },
    // 是否展示上传通道
    showUploadBtn() {
      // 第一次新增，不超过限制最大长度，则显示
      const limitLength = !this.maxLength || this.fileSet.length < this.maxLength;

      let editLimit = true;
      // 编辑时候，判断不合格的材料上传完成才显示----审核不通过
      if (this.applicant.file_status && this.applicant.file_status === 2) {
        editLimit = this.fileSet.every(img => !img.status || img.status !== 2); // 存在不合格的文件
      }
      
      return limitLength && editLimit;
    },
  },
  methods: {
    // 新增
    addFileSetItemList(newFileList) {
      if (!newFileList) return;
      // 非数组转化为数组
      if (!(newFileList instanceof Array)) {
        newFileList = [newFileList];
      }
      const newFileSet = this.fileSet.concat(newFileList);
      this.$emit('updateFileSet', newFileSet);
    },
    // 更新
    replaceFileSetItem(fileItem) {
      if (!fileItem || !fileItem.id) return;
      const index = this.fileSet.findIndex(img => img.id && img.id === fileItem.id);
      const newFileSet = utils.deepCopy(this.fileSet);
      newFileSet.splice(index, 1, fileItem);
      this.$emit('updateFileSet', newFileSet);
    },
    // 删除
    deleteFileSetItem(fileItem) {
      if (!fileItem || !fileItem.id) return;
      const index = this.fileSet.findIndex(img => img.id && img.id === fileItem.id);
      const newFileSet = utils.deepCopy(this.fileSet);
      newFileSet.splice(index, 1);
      this.$emit('updateFileSet', newFileSet);
    },
  },
};
</script>

<style lang="less" scoped>
.upload-reject-material-list {
  .reject-material-list {
    width: 100%;
    display: flex;
    flex: 0;
    flex-wrap: wrap;
  }
  .upload-item-box{
    width: 210px;
    height: 126px;
    border-radius: 4px;
    margin-left: 32px;
    margin-bottom: 8px;
    &:nth-child(4n+1){
      margin-left: 0;
    }
  }
  .reject-material-tips {
    font-size: 14px;
    color: #91999F;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/reject-product-applicant/components/upload-reject-material-list/upload-reject-material-list.vue